import _ from 'lodash';

export const compactFlatFilters = filters => {
  let arr=[];
  _.forEach(filters, filter=>{
    arr.push(_.omitBy(filter, _.isEmpty));
  });
  return _.assign.apply(_, arr)
}